import {
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  useDisclosure,
} from '@chakra-ui/react';
import React from 'react';

import Popover from 'ui/shared/chakra/Popover';
import IconSvg from 'ui/shared/IconSvg';

import SettingsColorTheme from './SettingsColorTheme';

const Settings = () => {
  const { isOpen, onToggle, onClose } = useDisclosure();

  return (
    <Popover
      placement="bottom-start"
      trigger="click"
      isOpen={ isOpen }
      onClose={ onClose }
    >
      <PopoverTrigger>
        <button
          aria-label="User settings"
          onClick={ onToggle }
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          <IconSvg name="gear_slim" boxSize={ 5 }/>
        </button>
      </PopoverTrigger>
      <PopoverContent overflowY="hidden" w="auto" fontSize="sm">
        <PopoverBody boxShadow="2xl" p={ 4 }>
          <SettingsColorTheme onSelect={ onClose }/>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default React.memo(Settings);
